import "./SchoolLibraryListing.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import { ToastContainer } from "react-toastify";
import SchoolLibraryListingViewModel from "./SchoolLibraryListingViewModel";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";

const SchoolLibraryListing = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    BooksArray,
    IsLoading,
  } = SchoolLibraryListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Library</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Library</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Library</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to={`/user/admin/library/add`}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {BooksArray &&
                            BooksArray.map((item, index) => {
                              // Book Name Start
                              const ArrayOfBookWords =
                                item?.BookName.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfBookWords.length;
                                i++
                              ) {
                                ArrayOfBookWords[i] =
                                  ArrayOfBookWords[i].charAt(0).toUpperCase() +
                                  ArrayOfBookWords[i].slice(1);
                              }
                              const StringOfBookWords =
                                ArrayOfBookWords.join(" ");
                              // Book Name End

                              // Book Type Start
                              const ArrayOfBookTypeWords =
                                item?.BookType.split(" ");
                              for (
                                var j = 0;
                                j < ArrayOfBookTypeWords.length;
                                j++
                              ) {
                                ArrayOfBookTypeWords[j] =
                                  ArrayOfBookTypeWords[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfBookTypeWords[j].slice(1);
                              }
                              const StringOfBookTypeWords =
                                ArrayOfBookTypeWords.join(" ");
                              // Book Type End
                              return (
                                <tr key={index}>
                                  <td>{item?.BookID}</td>
                                  <td>{StringOfBookWords}</td>
                                  <td>{StringOfBookTypeWords}</td>
                                  <td>
                                    {item?.BookStatus === "in-stock" ? (
                                      <span className="badge badge-success">
                                        In Stock
                                      </span>
                                    ) : (
                                      <span className="badge badge-danger">
                                        Out of Stock
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-end">
                                    <div className="actions">
                                      <Link
                                        onClick={() => {
                                          handleOpenDeleteDialog(item?.id);
                                        }}
                                        className="btn btn-sm bg-success-light me-2 "
                                      >
                                        <i className="fa-regular fa-trash-can"></i>
                                      </Link>
                                      <Link
                                        to={`/user/admin/library/update/${item?.id}`}
                                        className="btn btn-sm bg-danger-light"
                                      >
                                        <i className="fa-regular fa-pen-to-square"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {BooksArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this book?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </Fragment>
  );
};

export default SchoolLibraryListing;
